import { makeRequest, Service, identify } from 'utils/http';
import { CreateItemRequest } from 'trace-backend-sdk';

export async function createItemApi(item: CreateItemRequest) {
  return makeRequest(Service.createItem(item, await identify()));
}
